import React, { useContext } from 'react';

import { ProductDetailsContext } from '../context';

import style from '../style.module.css';

export const ProductDetailsModalHeader = () => {
  const { headerText } = useContext(ProductDetailsContext);

  return (
    <>
      <div className={style.title}>{headerText}</div>
    </>
  );
};
